import { Link, NavLink, useLocation } from "react-router-dom";

import { LogoIcon } from "@/components/branding/LogoIcon";
import { MOSQUE } from "@/config/constants";
import { isInMoreSection } from "@/lib/navigation";

interface NavItem {
  to: string;
  label: string;
  end?: boolean;
}

const links: NavItem[] = [
  { to: "/", label: "Home", end: true },
  { to: "/timetable", label: "Timetable" },
  { to: "/announcements", label: "Notices" },
  { to: "/development", label: "Development" },
  { to: "/more", label: "More" },
];

export function Header() {
  const location = useLocation();
  const moreActive = isInMoreSection(location.pathname);

  return (
    <header className="sticky top-0 z-20 border-b border-line bg-paper/95 backdrop-blur-sm">
      <div className="container-wide flex items-center justify-between py-3">
        <Link
          to="/"
          aria-label={`${MOSQUE.name} — home`}
          className="flex items-center gap-3 rounded-md focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-masjidGreen"
        >
          <LogoIcon className="h-10 w-10 shrink-0" />
          <div className="leading-tight">
            <div className="font-serif text-sm text-ink sm:text-base">{MOSQUE.name}</div>
            <div className="text-[10px] uppercase tracking-widest text-muted">
              {MOSQUE.village}, {MOSQUE.district}
            </div>
          </div>
        </Link>
        <nav className="hidden sm:block" aria-label="Primary">
          <ul className="flex gap-1 text-sm">
            {links.map((l) => {
              const isMore = l.to === "/more";
              return (
                <li key={l.to}>
                  <NavLink
                    to={l.to}
                    end={l.end ?? false}
                    className={({ isActive }) => {
                      const active = isMore ? moreActive : isActive;
                      return `rounded-md px-3 py-1.5 transition-colors ${
                        active
                          ? "bg-masjidGreen/10 text-masjidGreen"
                          : "text-ink/70 hover:text-ink"
                      }`;
                    }}
                  >
                    {l.label}
                  </NavLink>
                </li>
              );
            })}
          </ul>
        </nav>
      </div>
    </header>
  );
}
